/**
 * A boolean view preference remembered per browser. Storage is best-effort: when it is
 * unavailable (private mode, disabled) reads fall back and writes are dropped, so the
 * in-memory value still applies for the session.
 */
export const readStoredFlag = (storageKey: string, fallback: boolean): boolean => {
  try {
    const stored = window.localStorage.getItem(storageKey)
    return stored === null ? fallback : stored === 'true'
  } catch {
    return fallback
  }
}

export const writeStoredFlag = (storageKey: string, value: boolean): void => {
  try {
    window.localStorage.setItem(storageKey, String(value))
  } catch {
    // Persisting is best-effort — see above.
  }
}

export const readStoredString = (storageKey: string): string | null => {
  try {
    return window.localStorage.getItem(storageKey)
  } catch {
    return null
  }
}

export const writeStoredString = (storageKey: string, value: string): void => {
  try {
    window.localStorage.setItem(storageKey, value)
  } catch {
    // Persisting is best-effort — see above.
  }
}

export const removeStoredValue = (storageKey: string): void => {
  try {
    window.localStorage.removeItem(storageKey)
  } catch {
    // Persisting is best-effort — see above.
  }
}

/** The stored value parsed as JSON, or null when it is missing or malformed. */
export const readStoredJson = (storageKey: string): unknown => {
  const stored = readStoredString(storageKey)
  if (stored === null) {
    return null
  }
  try {
    return JSON.parse(stored) as unknown
  } catch {
    return null
  }
}
